/* eslint-disable no-console */

import { register } from 'register-service-worker'

register(`/service-worker.js`, {})

